import React, { useState, useEffect } from 'react'
import {PostData, fetchData} from '../Services/httpHandelars'

function SmtpSetup() {
    useEffect(() => {
        fetchData("/api/getMailSetup").then((data) => {
            const mailSetup = JSON.parse(data)
            setMailSetup(mailSetup);
            setId(mailSetup.success?._id)
            setForm({...form,
                senderName: mailSetup.success?.SenderName,
                host: mailSetup.success?.HOST,
                port: mailSetup.success?.PORT,
                userId: mailSetup.success?.UserID,
                password: mailSetup.success?.Password,
            })
        }).catch(e => console.log(e))
    },[])

    const [form, setForm] = useState({ senderName: "", host:"", port:"", userId: "", password: "" })
    const [mailSetup, setMailSetup] = useState("")
    const [id, setId] = useState("");

    const HandleChange = (e) => {
        
        if(e.target.value === "Gmail"){
            setForm({...form, port : "" , [e.target.name]: e.target.value})
        }
        else {
            setForm({ ...form, [e.target.name]: e.target.value })
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(id){
            const updateMailSetup = {
                senderName: form.senderName,
                hostName: form.host,
                portNumber: form.port,
                userID: form.userId,
                password: form.password,
                _id: id
            }
            PostData("/api/updateMailSetup", updateMailSetup).then((updated) => {
                console.log("updated --> 44",updated);
                if(updated.status){
                    
                }
            })

        }
        else {
            const data = {
                senderName: form.senderName,
                hostName: form.host || "Gmail",
                portNumber: form.port,
                userID: form.userId,
                password: form.password
            }

            PostData("/api/saveMailSetup", data).then((success) => {
                let data = success.success;
                setId(data._id)
            });
            
        }

    }

    return (
        <div>
            <div className='grid justify-center font-medium py-4 text-gray-700'>
                SMTP Setup
            </div>
            <div className='shadow overflow-hidden sm:rounded-md mt-5'>
                <div className='px-4 py-10 bg-white sm:p-6'>
                    <div className="grid grid-rows-5 grid-cols-1 gap-4 py-6 px-12">
                        <div>
                            <label htmlFor="senderName" className="block text-sm font-medium text-gray-700">
                            Sender Name
                            </label>
                            <input
                                type="text"
                                name="senderName"
                                value={form.senderName}
                                onChange={HandleChange}
                                required
                                id="senderName"
                                autoComplete="given-name"
                                className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            />
                        </div>

                        <div>
                            <label htmlFor="host" className="block text-sm font-medium text-gray-700">
                                Please Select Host
                            </label>
                            <select
                                type="text"
                                name="host"
                                id="host"
                                value={form.host}
                                required
                                onChange={HandleChange}
                                autoComplete="given-name"
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            >
                                <option>Gmail</option>
                                <option>Other</option>
                            </select>
                        </div>

                        {
                            form.host === "Other" && <div>
                            <label htmlFor="port" className="block text-sm font-medium text-gray-700">
                                Port
                            </label>
                            <input
                                type="text"
                                name="port"
                                required
                                id="port"
                                value={form.port}
                                onChange={HandleChange}
                                autoComplete="given-name"
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            />
                        </div>
                        }

                        

                        <div>
                            <label htmlFor="userId" className="block text-sm font-medium text-gray-700">
                                User ID
                            </label>
                            <input
                                type="text"
                                name="userId"
                                id="userId"
                                required
                                value={form.userId}
                                onChange={HandleChange}
                                autoComplete="given-name"
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password
                            </label>
                            <input
                                type="text"
                                name="password"
                                id="password"
                                required
                                value={form.password}
                                onChange={HandleChange}
                                autoComplete="given-name"
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            />
                        </div>
                    </div>
                    <div className='grid justify-center'>
                        <button
                            onClick={handleSubmit}
                            type='submit'
                            className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SmtpSetup